import { render, staticRenderFns } from "./relateCompany.vue?vue&type=template&id=f551c1be&scoped=true&"
import script from "./relateCompany.vue?vue&type=script&lang=js&"
export * from "./relateCompany.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/common/nav.less?vue&type=style&index=0&id=f551c1be&scoped=true&lang=less&"
import style1 from "../../../assets/css/common/operating.less?vue&type=style&index=1&id=f551c1be&scoped=true&lang=less&"
import style2 from "../../../assets/css/common/table.less?vue&type=style&index=2&id=f551c1be&scoped=true&lang=less&"
import style3 from "../../../assets/css/common/card.less?vue&type=style&index=3&id=f551c1be&scoped=true&lang=less&"
import style4 from "./relateCompany.vue?vue&type=style&index=4&id=f551c1be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f551c1be",
  null
  
)

export default component.exports